import {
  ACTIVATE_MAP,
  RECENTER,
  UPDATE_VIEWPORT,
  TOGGLE_PIN,
  SET_PLACING_PIN,
} from '../constants/actionTypes';

export function recenter() {
  return {
    type: RECENTER,
  };
}

/**
 * Activate the map and pass the initial viewport
 * @param {Object} e.target Leaflet Event
 * @return {Object} action
 */
export function activateMap({ target }) {
  const { lat, lng } = target.getCenter();
  const zoom = target.getZoom();

  return {
    type: ACTIVATE_MAP,
    viewport: {
      center: [lat, lng],
      zoom,
    },
  };
}

export function updateViewport(viewport) {
  return {
    type: UPDATE_VIEWPORT,
    viewport,
  };
}

export function togglePin() {
  return {
    type: TOGGLE_PIN,
  };
}

export function setPlacingPin(val) {
  return {
    type: SET_PLACING_PIN,
    payload: val,
  };
}
